import { requestBuilder } from '../../http/RequestBuilder';
import type { Disclosure } from '../types/BankAccount';

interface AcceptInviteBody {
    userId: string;
    bankAccountId: string;
    disclosures: Disclosure[];
}

export const useAcceptJointInvite = requestBuilder.mutation<
    { success: true },
    AcceptInviteBody
>({
    endpoint: '/api/bank-accounts/accept-joint-invite',
    method: 'POST',
});

export default useAcceptJointInvite;
